<script setup lang="ts">
import type { Product } from '~/types/shopware'
defineProps<{
  products: Product[]
}>()
</script>
<template>
  <ul v-if="products.length" class="products cul">
    <li v-for="product in products" :key="product.id">
      <ShopProductTeaser v-animate="{ animation: 'vertical-reveal' }" :product="product" />
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.products {
  display: grid;
  grid-template-columns: 100%;
  gap: 8px;
  @include breakpoint(ts) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @include breakpoint(d) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
